import useConfig from 'modules/config/state/use-config'
import Accordion from 'modules/ui/molecules/Accordion'
import { getAnalyticsInstance } from 'modules/analytics/analytics'

interface FaqProps {
  closeButtonDataId?: string
}

const Faq = ({ closeButtonDataId }: FaqProps) => {
  const config = useConfig()
  const analytics = getAnalyticsInstance()

  const handleFaqClick = (question: string, action: 'open' | 'close') => {
    if (action === 'open') {
      analytics.track('studio_faq_expand', {
        question,
        action,
      })
    }
  }

  return (
    <Accordion
      makeDataId={(item) => `faq-question-${item.id}`}
      items={config.faq.items.map((i) => ({ title: i.question, content: i.answer, id: i.id }))}
      lastFocusElementId={closeButtonDataId}
      onItemClick={handleFaqClick}
    />
  )
}

export default Faq
